import { StringFieldModel } from "@/common/commonForms";
import { Box, VBox } from "@/components-v2/Box";
import { Dialog } from "@/components-v2/Dialog";
import { MTextInput } from "@/components-v2/TextInput";
import { useDispatch, useMessageStore, useTranslation } from "@/stores/RootStoreContext";
import { observer } from "mobx-react";
import { useState } from "react";
import { InfoButton } from "@/components-v2/InfoButton";
import { DCEvent } from "@/events/eventsDomain";
import { isArray } from "lodash";

export const EditProjectNameDialog = observer(function ({
  name,
  onSave,
  onClose,
}: {
  name: StringFieldModel;
  onSave: ((name: string) => void) | ((name: string) => DCEvent[]) | DCEvent[];
  onClose: () => void;
}) {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const messageStore = useMessageStore();
  const dispatch = useDispatch();

  const onSubmit = (): void => {
    if (name.validate() && !isArray(onSave)) {
      setIsLoading(true);
      try {
        const result = onSave(name.validatedValue);
        if (isArray(result)) {
          dispatch(result);
        }
      } catch (error) {
        messageStore.showGeneralError();
        setIsLoading(false);
      }
    }
  };
  return (
    <Dialog
      title={t("dbot.new-project-name.title")}
      onCancel={onClose}
      onSubmit={isArray(onSave) ? onSave : onSubmit}
      submitLabel={t("save")}
      isSubmitting={isLoading}
    >
      <VBox>
        <Box>
          {t("dbot.new-project-name.label")}
          <InfoButton infoText={t("dbot.new-project-name.info")} />
        </Box>
        <MTextInput model={name} autoSelect />
      </VBox>
    </Dialog>
  );
});
